import { rem } from "polished";
import type { SponsorLayout } from "src/types";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

import {
  StyledSponsorCard,
  StyledSponsorCardLogo,
  StyledSponsorCardText,
} from "./sponsor-card/sponsor-card-component-styles";

export const CenteredHeader = styled.div`
  margin-bottom: ${rem(40)};

  .text-primitive.headingTwo {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export const StyledSponsorsList = withViewportStyle("div")<{
  layout: SponsorLayout;
}>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${StyledSponsorCard} {
    width: ${(props) =>
      props.layout === "golden"
        ? rem(392)
        : props.layout === "silver"
        ? rem(288)
        : rem(184)};

    padding: ${(props) =>
      props.layout === "golden"
        ? `${rem(75)} ${rem(68)} ${rem(32)} ${rem(68)}`
        : props.layout === "silver"
        ? `${rem(65)} ${rem(45)} ${rem(24)} ${rem(45)}`
        : `${rem(28)} ${rem(35)} ${rem(12)} ${rem(35)}`};

    ${(props) => props.$viewport.mobile`
      padding: ${(props) =>
        props.layout === "golden"
          ? `${rem(68)} ${rem(30)}`
          : props.layout === "silver"
          ? `${rem(90)} ${rem(73)}`
          : `${rem(30)} ${rem(27)}`};
    `}

    ${StyledSponsorCardLogo} {
      height: ${(props) =>
        props.layout === "golden"
          ? rem(144)
          : props.layout === "silver"
          ? rem(99)
          : rem(57)}
    }

    ${StyledSponsorCardText} {
      margin-top: ${(props) =>
        props.layout === "golden"
          ? `${rem(60)}`
          : props.layout === "silver"
          ? `${rem(30)}`
          : `${rem(20)}`};
    }
`;
